import { html, nothing } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import componentStyles from './link.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';
import {isExternalUrl, leavingSiteAlertHandler, externalLinkHoverText, renderIcon} from "../../utils/link";
import {fetchTitle} from "../../utils/dom";

export default class Link extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      href: { type: String },
      target: { type: String },
      indexTab: { type: Number },
      icon: { type: Boolean },
      styleclass: { type: String },
      white: { type: Boolean },
      ignoreExternalUrl: { type: Boolean },
      isNewWindow: { type: Boolean },
      ariaLabel: { type: String },
    };
  }

  onClick(event) {
    if (this.externalUrl && !leavingSiteAlertHandler()) {
      event.preventDefault()
    }

    if (this.href && this.target === '_blank') {
      window.open(this.href,'_blank', 'width=900,height=500');
      event.preventDefault();
    }
  }

  constructor() {
    super();
    this.href = '#';
    this.target = '_top';
    this.icon = false;
    this.ignoreExternalUrl = false;
    this.title = '';
    this.ariaLabel = '';
  }

  firstUpdated() {
    this.title = fetchTitle(this).trim()
    this.externalUrl = isExternalUrl(this.href)
    this.requestUpdate()
    this.ariaLabel = !ifDefined(this.ariaLabel) && ifDefined(this.icon) ? 'icon link' : this.ariaLabel;
  }

  render() {
    return html`
      <a
        @click="${this.onClick}"
        href="${this.href}"
        target="${this.target}"
        class="${classMap({
          'link': this.icon === false,
          'link--icon': this.icon === true,
          [`link--${this.styleclass}`]: !!this.styleclass,
          'link--external': this.externalUrl && !this.ignoreExternalUrl,
          'white': this.white,
        })}"
        title="${ifDefined(isExternalUrl(this.href) ? externalLinkHoverText(this.title) : this.title)}"
        aria-label="${ifDefined(this.ariaLabel ? this.ariaLabel : undefined)}"
        tabindex="${ifDefined(this.indexTab)}"
      >
        <slot></slot>
        ${renderIcon(this.href, this.ignoreExternalUrl)}
      </a>
    `;
  }
}

customElements.define('hf-link', Link);
